// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"_2gRQ6FLFPvpLyODQZ_ViZF"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PageHeader.scss
// module id = 384
// module chunks = 0